import React from 'react';

const Card = ({ children, className = "" }) => (
  <div
    className={`
      bg-white/80 dark:bg-geo-navy/80 
      backdrop-blur-md 
      border border-geo-navy/10 dark:border-white/10 
      rounded-2xl p-6 shadow-soft 
      transition-colors duration-300
      text-geo-navy dark:text-geo-sand /* <-- Added this line */
      ${className}
    `}
  >
    {children}
  </div>
);

export default Card;